import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-payment-order-grid-page',
  templateUrl: './payment-order-grid-page.component.html',
  styleUrls: ['./payment-order-grid-page.component.scss'],
})
export class PaymentOrderGridPageComponent {}
